import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { NonFloatingLabelProps } from './types';

type NonFloatingLabelStyleProps = Pick<NonFloatingLabelProps, 'disabled' | 'hasError'>;

const nonFloatingLabelBase = css`
  display: inline-block;
  font-size: ${theme.fontSize(16)};
  margin-bottom: ${theme.spacing(0.5)};
`;

const nonFloatingLabelDefaultColor = css`
  color: ${theme.colors.neutral50};
`;

const nonFloatingLabelDisabledColor = css`
  color: ${theme.colors.neutral20};
`;

const nonFloatingLabelHasErrorColor = css`
  color: ${theme.colors.status.critical};
`;

export const getNonFloatingLabelClassName = ({ disabled, hasError }: NonFloatingLabelStyleProps) =>
  cx(
    nonFloatingLabelBase,
    disabled ? nonFloatingLabelDisabledColor : hasError ? nonFloatingLabelHasErrorColor : nonFloatingLabelDefaultColor
  );

export const NonFloatingLabelStyles = {
  nonFloatingLabel: getNonFloatingLabelClassName,
};
